import TableModulockerTemplate from "./TableModulockerTemplate";
export default TableModulockerTemplate;
export { default as TableModulockerTemplate } from './TableModulockerTemplate';